import React, { useEffect } from "react";
import PageTemplate from "template/PageTemplate";
import { Spin } from "antd";
import { useHistory } from "react-router-dom";
import useFetch from "hooks/useFetch";
import { createFrequentlyAskedQuestionRequest } from "services/frequentlyAskedQuestion";
import FrequentlyAskedQuestionForm from "../Form";

export default function BackofficeFrequentlyAskedQuestionCreate() {
  const history = useHistory();
  const { goBack } = history;
  const initialValues = {
    ds_titulo: "",
    ds_descricao: "",
    fg_ativo: true,
  };
  const [{ isFetching, data }, createRequest] = useFetch(
    createFrequentlyAskedQuestionRequest,
    "",
    false,
    null
  );

  useEffect(() => {
    if (data) {
      history.goBack();
    }
  }, [history, data]);

  return (
    <PageTemplate title="Criação de Pergunta Frequente">
      <Spin spinning={isFetching}>
        <FrequentlyAskedQuestionForm
          initialValues={initialValues}
          handleSubmitForm={createRequest}
          handleCancel={goBack}
        />
      </Spin>
    </PageTemplate>
  );
}
